import * as DrivingTestModule from 'Modules/DrivingTestModule';
import { DrivingTest } from '../EnumTypes/ActionEnumTypes';

const init = () => ({
  type: DrivingTest.FINISH_DRIVING_TEST_INIT,
});

export const success = (data) => ({
  type: DrivingTest.FINISH_DRIVING_TEST_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: DrivingTest.FINISH_DRIVING_TEST_FAILURE,
});

const finishDrivingTest = (uuid) => async (dispatch) => {
  dispatch(init());
  try {
    const response = await DrivingTestModule.Connector.finishDrivingTest(uuid);
    dispatch(success(response.data.drivingTest));
    return response.data.drivingTest;
  } catch (err) {
    dispatch(failure());
    return false;
  }
};

export default finishDrivingTest;
